import { render, staticRenderFns } from "./AnimateNumber.vue?vue&type=template&id=aa0dc7b0&"
import script from "./AnimateNumber.vue?vue&type=script&lang=js&"
export * from "./AnimateNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports